import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Select, message } from 'antd';
import { SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { departmentApi, photoTypeApi } from '../../services/api';

const DepartmentForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [photoTypeOptions, setPhotoTypeOptions] = useState([]);
  const navigate = useCompanyNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  useEffect(() => {
    const loadPhotoTypes = async () => {
      try {
        const res = await photoTypeApi.all();
        setPhotoTypeOptions(
          (res.data || []).map(pt => ({ label: pt.name, value: String(pt.id) }))
        );
      } catch {}
    };
    loadPhotoTypes();
  }, []);

  useEffect(() => {
    if (isEdit) {
      fetchDepartment();
    }
  }, [id]);

  const fetchDepartment = async () => {
    try {
      const res = await departmentApi.detail(id);
      form.setFieldsValue({
        name: res.data.name,
        photo_types: res.data.photo_types ? res.data.photo_types.split(',') : [],
        can_create_batch: res.data.can_create_batch,
        can_copy_batch: res.data.can_copy_batch,
        status: res.data.status,
      });
    } catch (err) {
      message.error('获取部门详情失败');
      navigate('/admin/departments');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const data = {
        ...values,
        photo_types: values.photo_types.join(','),
      };
      if (isEdit) {
        await departmentApi.update(id, data);
        message.success('更新成功');
      } else {
        await departmentApi.create(data);
        message.success('创建成功');
        navigate('/admin/departments');
      }
    } catch (err) {
      message.error(err.response?.data?.message || '操作失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24, gap: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/admin/departments')}>返回</Button>
        <h2 style={{ margin: 0 }}>{isEdit ? '编辑部门' : '新增部门'}</h2>
      </div>

      <Card style={{ maxWidth: 600 }}>
        <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ can_create_batch: 0, can_copy_batch: 0, status: 1 }}>
          <Form.Item name="name" label="部门名称" rules={[{ required: true, message: '请输入部门名称' }]}>
            <Input placeholder="如：切料部门" />
          </Form.Item>

          <Form.Item name="photo_types" label="允许的照片类型" rules={[{ required: true, message: '请选择照片类型' }]}>
            <Select
              mode="multiple"
              placeholder="选择允许上传的照片类型"
              options={photoTypeOptions}
            />
          </Form.Item>

          <Form.Item name="can_create_batch" label="可创建批次">
            <Select options={[
              { label: '否', value: 0 },
              { label: '是', value: 1 },
            ]} />
          </Form.Item>

          <Form.Item name="can_copy_batch" label="可复制批次">
            <Select options={[
              { label: '否', value: 0 },
              { label: '是', value: 1 },
            ]} />
          </Form.Item>

          <Form.Item name="status" label="状态">
            <Select options={[
              { label: '启用', value: 1 },
              { label: '禁用', value: 0 },
            ]} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading} style={{ background: '#8B7355' }}>
              {isEdit ? '保存修改' : '创建部门'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default DepartmentForm;
